import React from "react";
import classNames from "classnames";
import ModalImage from "react-modal-image";

const EntryExitTableRow = ({
  local_entry_time,
  local_exit_time,
  vehicle_state_and_plate,
  lpr_filename,
  access_credential,
  duration_in_time,
  payment,
  entry_mechanism,
  transaction_id,
  transit_id,
  garage_id,
  closed_transit,
  permit_busy_valid,
  entered_before_cleared_inventory,
  transit_type,
  clickHandler,
  validClickHandler
}) => (
  <tr
    className={classNames("transitrow", "transit-record", {
      "closed-transit": closed_transit
    })}
    data-transit-id={transit_id}
    onClick={() => clickHandler(garage_id, transit_id)}
  >
    <td className={entered_before_cleared_inventory ? "entry_time_before_inventory_clear" : "" } style={{fontWeight:  transit_type == "entry" ? "bold" : "normal"}}>{local_entry_time}</td>
    <td style={{fontWeight:  transit_type == "exit" ? "bold" : "normal"}}>{local_exit_time}</td>
    <td className="lpr_cell">{vehicle_state_and_plate}
      {lpr_filename == null ? "" :       
       <ModalImage
          small={"/camera.png"}
          large={"/garages/1/lpr_image/"+lpr_filename}
          alt="LPR Image"
          className="lpr_icon"
       />
      }      
    </td>
    <td>{access_credential}</td>
    <td>{duration_in_time}</td>
    <td>{payment}</td>
    <td className="transit-entry-td">
      {entry_mechanism+" "}
      {entry_mechanism && validClickHandler && entry_mechanism.includes("Permit Busy") && (
        <a onClick={() => validClickHandler(garage_id, transit_id)}>Valid</a>
      )}
      {permit_busy_valid && (
        <span
          className="glyphicon glyphicon-ok"
          style={{ color: "green", marginLeft: "4px" }}
        ></span>
      )}
    </td>
    <td>{transaction_id}</td>
  </tr>
);

export default EntryExitTableRow;
